export default {
      id: "ic-nav-exit-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic-nav-exit-usage",
      toString: function () {
        return this.url;
      }
    }